document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".custom-popup");
  const closeBtn = document.querySelector(".custom-popup__close");
  const overlay = document.querySelector(".custom-popup__overlay");

  if (popup && closeBtn && overlay) {
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      popup.style.display = "none";
    });
  }
});
